export const EXTENSIONS = [
  "DWG",
  "XLSX",
  "WORDX",
  "CSV",
  "PDF",
  "DXF",
  "DGN",
  "IFC",
  "RVT",
  "SHP",
  "SHX",
  "DBF",
  "PRJ",
  "GEOJSON",
];

export const STATUS = ["A_TRAITER", "EN_COURS", "ACTIF_EN_ATTENTE"];

export const ACCEPTED_TYPES = {
  "image/jpeg": [".jpg", ".jpeg"],
  "application/pdf": [".pdf"], // PDF
  "application/msword": [".doc"], // DOC
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [
    ".docx",
  ], // DOCX
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
    ".xlsx",
  ], // XLSX
  "text/csv": [".csv"], // CSV
  "text/plain": [".txt"], // TXT
  "application/dwg": [".dwg"], // DWG
  "application/x-dwg": [".dwg"], // Another DWG MIME type
  // "image/vnd.dwg": [], // Image MIME type for DWG
  "application/dxf": [".dxf"], // DXF
  "application/dgn": [".dgn"], // DGN
  "application/ifc": [".ifc"], // IFC
  // SHP files
  "application/x-esri-shape": [".shp"],
  "application/x-shp": [".shp", ".shp.xml"],
  "application/x-shx": [".shx"],
  "application/x-dbf": [".dbf"],
  "application/prj": [".prj"],
  "application/sbn": [".sbn"],
  "application/sbx": [".sbx"],
  "application/cpg": [".cpg"],
  "application/kml": [".kml"],
  "application/geo+json": [".geojson"],
};
export const typologiepieceOptions = [
 { value: "", label: "Aucune" },
  { value: "Local_de_stockage", label: "Local de stockage" },
  { value: "Coffre", label: "Coffre" },
  { value: "Cave", label: "Cave" },
  { value: "Escalier", label: "Escalier" },
  { value: "Atelier", label: "Atelier" },
  { value: "Garage", label: "Garage" },
  { value: "Degagement", label: "Degagement" },
  { value: "Bureau", label: "Bureau" },
  { value: "Salle_de_reunion", label: "Salle de réunion" },
  { value: "Rangement", label: "Rangement" },
  { value: "Wc", label: "wc" },
  { value: "Cuisine", label: "Cuisine" },
  { value: "Vestiaire", label: "Vestiaire" },
  { value: "Salle_de_bain", label: "Salle de bain" },
  { value: "Grenier", label: "Grenier" },
  { value: "Archives", label: "Archives" },
  { value: "Local", label: "Local" },
  { value: "Chaufferie", label: "Chaufferie" },
  { value: "Hall_activite", label: "Hall activité" },
  { value: "Circulation", label: "Circulation" },
  { value: "Economate", label: "Economate" },
  { value: "Machinerie", label: "Machinerie" },
  { value: "Entree", label: "Entree" },
  { value: "Placard", label: "Placard" },
  { value: "Chambre", label: "Chambre" },
  { value: "Sejour", label: "Séjour" },
  { value: "Reserve", label: "Réserve" },
  { value: "Salle_de_restauration", label: "Salle de restauration" },
  { value: "Palier", label: "Palier" },
  { value: "Chambre_froide", label: "Chambre froide" },
  { value: "Magasin", label: "Magasin" },
  { value: "Entresol", label: "Entresol" },
  { value: "Local_menage", label: "Local ménage" },
  { value: "Salle_de_repos", label: "Salle de repos" },
  { value: "Douche", label: "Douche" },
  { value: "Local_technique", label: "Local technique" },
  { value: "Entrepot", label: "Entrepôt" },
  { value: "Salle_de_restaurant", label: "Salle de restaurant" },
  { value: "Puits_de_lumiere", label: "Puits de lumière" },
  { value: "Salon", label: "Salon" },
  { value: "Dressing", label: "Dressing" },
  { value: "Sanitaire", label: "Sanitaire" },
  { value: "Salle_a_manger", label: "Salle à manger" },
  { value: "Debarras", label: "Débarras" },
  { value: "Veranda", label: "Véranda" },
  { value: "Séjour/cuisine", label: "Séjour/Cuisine" },
  { value: "Sdb/wc", label: "SDB/WC" },
  { value: "Salle_deau", label: "Salle d'eau" },
  { value: "Salle_de_vente", label: "Salle de vente" },
  { value: "Salle_de_bain_wc", label: "Salle de bain_Wc" },
  { value: "Combles", label: "Combles" },
  { value: "Cage_escalier", label: "Cage escalier" },
  { value: "Salle_de_douches", label: "Salle de douches" }

];

export const typeEspaceOptions = [
  { value: "", label: "Aucune" },
  { value: "APPARTEMENT", label: "Appartement" },
  { value: "MAGASIN", label: "Magasin" },
  { value: "RESTAURANT", label: "Restaurant" },
  { value: "BUREAU", label: "Bureau" },
  { value: "MAISON_MITOYENNE", label: "Maison mitoyenne" },
];

export const nodesEspace = [
  { key: "", label: "Aucune" },
  { key: "APPARTEMENT", label: "Appartement" },
  { key: "MAGASIN", label: "Magasin" },
  { key: "RESTAURANT", label: "Restaurant" },
  { key: "BUREAU", label: "Bureau" },
  { key: "MAISON_MITOYENNE", label: "Maison mitoyenne" },
];

export const nodesPieces = [
   { key: "", label: "Aucune" },
  { key: "Local_de_stockage", label: "Local de stockage" },
  { key: "Coffre", label: "Coffre" },
  { key: "Cave", label: "Cave" },
  { key: "Escalier", label: "Escalier" },
  { key: "Atelier", label: "Atelier" },
  { key: "Garage", label: "Garage" },
  { key: "Degagement", label: "Degagement" },
  { key: "Bureau", label: "Bureau" },
  { key: "Salle_de_reunion", label: "Salle de réunion" },
  { key: "Rangement", label: "Rangement" },
  { key: "Wc", label: "wc" },
  { key: "Cuisine", label: "Cuisine" },
  { key: "Vestiaire", label: "Vestiaire" },
  { key: "Salle_de_bain", label: "Salle de bain" },
  { key: "Grenier", label: "Grenier" },
  { key: "Archives", label: "Archives" },
  { key: "Local", label: "Local" },
  { key: "Chaufferie", label: "Chaufferie" },
  { key: "Hall_activite", label: "Hall activité" },
  { key: "Circulation", label: "Circulation" },
  { key: "Economate", label: "Economate" },
  { key: "Machinerie", label: "Machinerie" },
  { key: "Entree", label: "Entree" },
  { key: "Placard", label: "Placard" },
  { key: "Chambre", label: "Chambre" },
  { key: "Sejour", label: "Séjour" },
  { key: "Reserve", label: "Réserve" },
  { key: "Salle_de_restauration", label: "Salle de restauration" },
  { key: "Palier", label: "Palier" },
  { key: "Chambre_froide", label: "Chambre froide" },
  { key: "Magasin", label: "Magasin" },
  { key: "Entresol", label: "Entresol" },
  { key: "Local_menage", label: "Local ménage" },
  { key: "Salle_de_repos", label: "Salle de repos" },
  { key: "Douche", label: "Douche" },
  { key: "Local_technique", label: "Local technique" },
  { key: "Entrepot", label: "Entrepôt" },
  { key: "Salle_de_restaurant", label: "Salle de restaurant" },
  { key: "Puits_de_lumiere", label: "Puits de lumière" },
  { key: "Salon", label: "Salon" },
  { key: "Dressing", label: "Dressing" },
  { key: "Sanitaire", label: "Sanitaire" },
  { key: "Salle_a_manger", label: "Salle à manger" },
  { key: "Debarras", label: "Débarras" },
  { key: "Veranda", label: "Véranda" },
  { key: "Séjour/cuisine", label: "Séjour/Cuisine" },
  { key: "Sdb/wc", label: "SDB/WC" },
  { key: "Salle_deau", label: "Salle d'eau" },
  { key: "Salle_de_vente", label: "Salle de vente" },
  { key: "Salle_de_bain_wc", label: "Salle de bain_Wc" },
  { key: "Combles", label: "Combles" },
  { key: "Cage_escalier", label: "Cage escalier" },
  { key: "Salle_de_douches", label: "Salle de douches" },
];

export const FormatExtentions = [
  { value: "pdf", label: "PDF" },
  { value: "docx", label: "Word" },
  { value: "xlsx", label: "Excel" },
  { value: "dgn", label: "DGN" },
  { value: "dxf", label: "DXF" },
  { value: "dwg", label: "DWG" },
  { value: "shp", label: "SHP" },
  { value: "shx", label: "SHX" },
  { value: "dbf", label: "DBF" },
  { value: "geojson", label: "GEOJSON" },
];
